'use strict';

/**
 * @classname AnchorCancel
 * @classdesc キャンセルボタン
 */
export default class AnchorCancel {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--cancel
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._orderId = $e.attr('data-order-id');
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof AnchorCancel
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		$('#orderId').val(this._orderId);
	};
};
